import { combineReducers } from 'redux';

import vaultRequestReducer from './vaultRequest';
import hyperlinkReducer from './hyperlink';
import cardDetailsReducer from './cardDetails';
import vaultCardReducer from './vaultCard';
import buyerContactListReducer from './buyerContactList';
import vaultRequestListReducer from './vaultRequestList';
import contactSearchCriteriaReducer from './contactSearchCriteria';
import contactRecordsReducer from './contactRecords';
import buyerContactReducer from './buyerContact';
import buyerRecordsReducer from './buyerRecords';
import supplierRecordsReducer from './supplierRecords';
import userActListReducer from './userActList';
import userActSearchCriteriaReducer from './userActSearchCriteria';
import userActivityReducer from './userActivity';
import vaultActListReducer from './vaultActList';
import vaultActSearchCriteriaReducer from './vaultActSearchCriteria';
import vaultingActivityReducer from './vaultingActivity';
import supplierSecretsReducer from './supplierSecrets';
import vaultingRequestsSearchCriteriaReducer from './vaultingRequestsSearchCriteria';
import vaultingRequestsReducer from './vaultingRequests';
import userReducer from './user';

const allReducers = combineReducers({
  vaultRequest: vaultRequestReducer,
  hyperlink: hyperlinkReducer,
  cardDetails: cardDetailsReducer,
  vaultCard: vaultCardReducer,
  buyerContactList: buyerContactListReducer,
  vaultRequestList: vaultRequestListReducer,
  contactSearchCriteria: contactSearchCriteriaReducer,
  vaultingRequestsSearchCriteria: vaultingRequestsSearchCriteriaReducer,
  contactRecords: contactRecordsReducer,
  buyerContact: buyerContactReducer,
  buyerRecords: buyerRecordsReducer,
  supplierRecords: supplierRecordsReducer,
  userActList: userActListReducer,
  userActSearchCriteria: userActSearchCriteriaReducer,
  userActivity: userActivityReducer,
  vaultActList: vaultActListReducer,
  vaultActSearchCriteria: vaultActSearchCriteriaReducer,
  vaultingActivity: vaultingActivityReducer,
  supplierSecrets: supplierSecretsReducer,
  vaultingRequests: vaultingRequestsReducer,
  user: userReducer,
});

export default allReducers;
